import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import { FilterConfig, INNITIAL_REQUEST_REASON, RequestReason } from '@employee-pages/badge-request-page/employee-badge-requests';
import { BadgeReasonEnum } from '@employee-models/data.enums';
import { UsersService } from 'DBadgeEmployee-app/src/app/core/services/data-access/users.service';
import { IPPMDSearchInMyLocationResult } from '@employee-models/data.models';

@Component({
    selector: 'ppmd-employee-request-details-desktop',
    templateUrl: './ppmd-employee-request-details-desktop.component.html',
    styleUrls: ['./ppmd-employee-request-details-desktop.component.less']
})

export class PPMDEmployeeRequestDetailsDesktopComponent implements OnChanges {
    @Input() requestData: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() requestReasonPayload: EmployeeModels.CM.IBadgeRequestPayloadModel;
    @Input() tabs: Array<RequestReason>;
    @Input() locationFilterConfig: FilterConfig;

    @Output() onRequestReasonSelect = new EventEmitter<RequestReason>();
    @Output() onLocationSelect = new EventEmitter<number>();
    @Output() onPreferredFullNameSelected = new EventEmitter<boolean>();
    @Output() onBloodGroupSelected = new EventEmitter<string>();
    @Output() onPPMDUserSelected = new EventEmitter<IPPMDSearchInMyLocationResult>();
    ppmdEmailAddress: string;
    ppmdDeliveryFacilityName: string;
    ppmdServiceLineOrArea: string;
    disableTabs: boolean = true;
    forEmployee: boolean = true;

    readonly badgeRequestTypeEnum = EmployeeModels.DE.BadgeRequestTypeEnum;
    readonly badgeChangeReasonsCategories = BadgeReasonEnum;


    constructor(
        private usersService: UsersService
    ) {

    }
    lookupPeople$ = (searchText: string) => this.usersService.searchPPMDEmployee(searchText);

    lookupPrehire$ = (searchText: string) => this.usersService.searchPPMDPrehire(searchText);
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.requestData && changes.requestData.currentValue) {
            this.disableTabs = !this.requestData.canUploadBadgeRequest || !this.ppmdEmailAddress;
        }
        if (changes.tabs && changes.tabs.currentValue) {
            this.tabs = changes.tabs.currentValue;
        }
    }

    get isNoteBlockShown(): boolean {
        return [
            this.badgeChangeReasonsCategories.BadgeLost,
            this.badgeChangeReasonsCategories.BadgeStolen,
            this.badgeChangeReasonsCategories.BadgeDamaged
        ].includes(this.requestReasonPayload.reason);
    }

    get isResubmission(): boolean {
        return this.requestData.badgeRequestType === EmployeeModels.DE.BadgeRequestTypeEnum.Resubmission
            && this.requestData.lastBadgeRequestReason in EmployeeModels.DE.BadgeReasonEnum;
    }

    get isFullNameChecked(): boolean {
        if (this.requestReasonPayload.isNameChanges) {
            return !this.requestReasonPayload.isPreferredFullName;
        }

        return !this.requestData.isPreferredFullName || (this.requestData.isPreferredFullName && !this.isResubmission);
    }

    get selectedBloodType(): string {
        return this.requestData.bloodGroups
            .find(i => i.bloodGroupId === this.requestReasonPayload.bloodGroupId)?.bloodGroupName || '';
    }

    pickRequestReason(tab: RequestReason): void {
        this.onRequestReasonSelect.emit(tab);
    }

    locationChanged(site: EmployeeModels.DM.ISiteDto): void {
        this.onLocationSelect.emit(site.siteId);
    }

    onChangeName(isPreferredFullName: boolean): void {
        this.onPreferredFullNameSelected.emit(isPreferredFullName);
    }

    onBloodGroupChange(bloodGroupName: string): void {
        this.onBloodGroupSelected.emit(bloodGroupName);
    }

    ppmdTypeChanged(isForEmployee: boolean): void {
        this.forEmployee = isForEmployee;
        // if (!isForEmployee) {
        //     this.tabs = INNITIAL_REQUEST_REASON;
        // }
        this.ppmdUserChanged(null);

    }

    ppmdUserChanged(user: IPPMDSearchInMyLocationResult): void {
        if (user) {
            user.email = user?.email ?? user?.personalEmail;
            user.alias = user?.alias ?? user?.aliasPhd;
            user.isPrehire = !this.forEmployee;
        }
        else{
            user = {isPrehire: !this.forEmployee } as IPPMDSearchInMyLocationResult;
        }
        this.ppmdEmailAddress = user?.email;
        this.ppmdDeliveryFacilityName = user?.siteName;
        // @ts-ignore   TODO  BE update models
        this.ppmdServiceLineOrArea = user?.businessLineMediumText;
        this.disableTabs = !this.requestData.canUploadBadgeRequest || !this.ppmdEmailAddress;
        this.onPPMDUserSelected.emit(user);
    }

}
